export default `
<section class="bg-white first">
<div class="href"><a href="++{{section17link}}">++{{section17linktext}}</a></div>
<div class="img1 mt-5 mb-4">
    <img src="++{{section17Image}}">
</div>
</section>

`